import template from './bMonthPicker.html';

export function bMonthPickerDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: bMonthPickerController,
    controllerAs: 'bMonthPicker',
    bindToController: true,
    scope: {
      onApplyRange: "=",
      selectedDates: "=",
      monthsEllipsis: "=", //show first months, ellipsis (...), last month in range
      monthlyIncomes: "="
    }
  };
}

class bMonthPickerController {
  constructor($scope, $translate) {
    'ngInject';

    this.$translate = $translate;
    this.$scope = $scope;
    this.init();
    this.calendarHidden = true;
    this.maximumNrOfMonths = 4;
    this.isOnCalendar = false;
    this.$scope.$watch(() => this.selectedDates, () => this.generateInitialRangeIndexes(), true);


  }

  init() {
    this.initYearLabels();
    this.initMonthLabels();
    this.initMonthsData();
    this.initRangeIndexes();
    this.initViewSlices();
    this.shownYearIndex = this.years.findIndex(year => year === (new Date()).getFullYear());
    this.sliceDataIntoView();
    this.checkYearArrows();
    this.checkDisabledButtons();
    document.addEventListener("click", ()=>{
      if(!this.isOnCalendar) {
        this.closeCalendar();
        this.$scope.$digest();
      }
    });
  }

  initYearLabels() {
    const currentYear = (new Date()).getFullYear();
    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    this.years = range(currentYear-5, currentYear, 1);
  }

  initMonthLabels() {
    // this.months = new Array(12).fill(0).map((_, i) => {
    //   return new Date(`${i + 1}/1`).toLocaleDateString('en-EN', {month: 'short'});
    // }); //not working in firefox

    const Jan = this.$translate.instant('MONTHS.JAN');
    const Feb = this.$translate.instant('MONTHS.FEB');
    const Mar = this.$translate.instant('MONTHS.MAR');
    const Apr = this.$translate.instant('MONTHS.APR');
    const May = this.$translate.instant('MONTHS.MAY_SHORT');
    const Jun = this.$translate.instant('MONTHS.JUN');
    const Jul = this.$translate.instant('MONTHS.JUL');
    const Aug = this.$translate.instant('MONTHS.AUG');
    const Sep = this.$translate.instant('MONTHS.SEP');
    const Oct = this.$translate.instant('MONTHS.OCT');
    const Nov = this.$translate.instant('MONTHS.NOV');
    const Dec = this.$translate.instant('MONTHS.DEC');

    this.months = [Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec];
  }

  generateInitialRangeIndexes() {
    if (!this.selectedDates) return;
    const monthNumberFrom = parseInt(this.selectedDates[0], 10);
    const monthNumberTo = parseInt(this.selectedDates[2], 10);

    const monthNameFrom = this.months[monthNumberFrom-1];
    const monthYearFrom = this.selectedDates[1];
    const monthNameTo = this.months[monthNumberTo-1];
    const monthYearTo = this.selectedDates[3];

    this.shownYearIndex = this.years.findIndex(year => year === parseInt(monthYearFrom));
    this.sliceDataIntoView();
    this.checkYearArrows();

    const indexFrom = this.monthsData.findIndex(el => el.monthName === monthNameFrom && el.monthYear == monthYearFrom);
    const indexTo = this.monthsData.findIndex(el => el.monthName === monthNameTo && el.monthYear == monthYearTo);
    this.rangeIndexes = [indexFrom, indexTo];

    this.monthsData.forEach((month, index) => {
      if ((this.rangeIndexes[0] <= index) && (index <= this.rangeIndexes[1])) {
        month.isInRange = true;
      }
      if (this.rangeIndexes[0] === index) {
        month.isUpperEdge = true;
      }
      if (this.rangeIndexes[1] === index) {
        month.isLowerEdge = true;
      }
    });
    this.generateVisibleMonthsInRange();
  }

  reverseMonthsInRange() {
    return this.monthsData.filter(m => m.isInRange).slice();
  }

  showEdgeMonthsAndEllipsisBetween() {
    this.monthsInRange.forEach((month, index, array) => {
      month.isYearVisible = false;

      if(index==0) month.isMonthVisible = true;
      if(index == array.length-2) month.showEllipsis = true;
      if(index == array.length-1) {
        month.isMonthVisible = true;
        month.isYearVisible = true;
      }
    });
  }

  generateVisibleMonthsInRange() {
    this.monthsInRange = this.reverseMonthsInRange();
    this.allMonthsVisible = this.monthsInRange.length <= this.maximumNrOfMonths; //show maximum 9 month spans in time range (this.maximumNrOfMonths)
    this.moreThanOneYearSpan = !!this.monthsInRange.find((month) =>  month.monthYear !== this.monthsInRange[0].monthYear);

    if(this.moreThanOneYearSpan) {
      this.monthsInRange.forEach((month, index, array) => {
        if(array[index-1] && month.monthYear !== array[index-1].monthYear) {
          month.isYearVisible = true;
        }
      });
    }

    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      // true for mobile device
      this.allMonthsVisible = false;
      if (this.monthsInRange.length > 3) {
        this.moreThanOneYearSpan = true;
        return this.showEdgeMonthsAndEllipsisBetween();
      } else {
        return this.monthsInRange.forEach((month) => {
          month.isMonthVisible = true;
        });
      }
    }

    // if less or equal to 9 month spans in selected time range
    if(this.allMonthsVisible) return;


    // if more than 9 month spans in selected time range
    if(this.moreThanOneYearSpan) {
      // more than one year time span
      const changeYearIndexes = [];
      let changeIndex;
      this.monthsInRange.forEach((month, index, array) => {
        if(array[index-1] && month.monthYear !== array[index-1].monthYear) {
          changeIndex = index;
          changeYearIndexes.push(changeIndex);
        }
      });

      if (changeYearIndexes.length == 1) {
        // one year change in time span

        this.monthsInRange.forEach((month, index, array) => {
          if(index==0) month.isMonthVisible = true;
          if(index==1) month.isMonthVisible = true;

          // one month before year change
          if(index-1 == changeYearIndexes.find(el => el == index-1)) {
            month.isMonthVisible = true;
          }

          // month of year change /Dec/
          if(index == changeYearIndexes.find(el => el == index)) month.isMonthVisible = true;

          // one month after year change /Jan/ and ellipsis
          if(index+1 == changeYearIndexes.find(el => el == index+1)) month.isMonthVisible = true;
          if(index+2 == changeYearIndexes.find(el => el == index+2) && index !==0) month.showEllipsis = true;

          if(index == array.length-1) month.isMonthVisible = true;
          if(index == array.length-2) month.isMonthVisible = true;
          if(index == array.length-3 && month.monthName != 'Jan' && month.monthName != 'Dec') month.showEllipsis = true;
        });
      } else if (changeYearIndexes.length == 2 ) {
        // double year change in time span

        this.monthsInRange.forEach((month, index, array) => {
          if(index==0) month.isMonthVisible = true;

          // month of year change /Dec/
          if(index == changeYearIndexes.find(el => el == index)) month.isMonthVisible = true;

          // one month after year change /Jan/ and ellipsis
          if(index+1 == changeYearIndexes.find(el => el == index+1)) month.isMonthVisible = true;
          if(index+2 == changeYearIndexes.find(el => el == index+2) && index !==0) month.showEllipsis = true;

          if(index == array.length-1) month.isMonthVisible = true;
          if(index == array.length-2 && month.monthName != 'Jan' && month.monthName != 'Dec') month.showEllipsis = true;
        });
      } else {
        // if there are more than two year changes show only edge months
        this.showEdgeMonthsAndEllipsisBetween();
      }

    } else {
      // if one year only time span - show this.monthsEllipsis first months, ellipsis (...), last month in range
      this.monthsInRange.forEach((month, index, array) => {
        if(index <= this.monthsEllipsis-1) month.isMonthVisible = true;
        if(index == array.length-1) month.isLastInRange = true;
        if(index == array.length-2) month.showEllipsis = true;
      });
    }
  }

 initMonthsData() {
    this.monthsData = [];
    this.years.forEach( year => {
      this.months.forEach( month => {
        this.monthsData.push({
          monthName: month,
          monthYear: year,
          isInRange: false,
          isLowerEdge: false,
          isUpperEdge: false
        });
      });
    });
  }

  initRangeIndexes() {
    this.rangeIndexes = [ null, null ];
  }

  initViewSlices() {
    this.monthViewSlicesIndexes = [];
    this.years.forEach((_year, index) => {
      if (index === 0) {
        this.monthViewSlicesIndexes.push(0);
      } else {
        this.monthViewSlicesIndexes.push(this.monthViewSlicesIndexes[index-1] + 12);
      }
    });
  }

  sliceDataIntoView() {
    this.globalIndexOffset = this.monthViewSlicesIndexes[this.shownYearIndex];
    this.monthsDataSlice = this.monthsData.slice(this.globalIndexOffset, this.globalIndexOffset + 12);
  }

  checkYearArrows() {
    this.isPrevDisabled = this.shownYearIndex === 0;
    this.isNextDisabled = this.shownYearIndex === this.years.length-1;
  }

  checkDisabledButtons() {
    this.areButtonsDisabled = !this.monthsData[this.rangeIndexes[0]] && !this.monthsData[this.rangeIndexes[1]];
  }

  incrementYear() {
    if (!this.isNextDisabled) {
      this.shownYearIndex++;
      this.sliceDataIntoView();
      this.checkYearArrows();
    }
  }

  decrementYear() {
    if (!this.isPrevDisabled) {
      this.shownYearIndex--;
      this.sliceDataIntoView();
      this.checkYearArrows();
    }
  }

  onHoverNext() {
    if (this.rangeIndexes[0] && !this.rangeIndexes[1]) {
      this.tempRangeIndexes[1] = this.globalIndexOffset+12;
      this.onHover(this.globalIndexOffset+12);
    }
  }

  onHoverPrevious() {
    if (this.rangeIndexes[0] && !this.rangeIndexes[1]) {
      this.tempRangeIndexes[0] = this.globalIndexOffset;
      this.tempRangeIndexes[1] = this.rangeIndexes[0];
      this.onHover(this.globalIndexOffset-13);
    }
  }

  onHover(indexHovered) {
    this.tempRangeIndexes = [];

    if (this.rangeIndexes[0] !== null && this.rangeIndexes[1] === null) {
      this.tempRangeIndexes[0] = this.rangeIndexes[0];
      this.tempRangeIndexes[1] = this.globalIndexOffset + indexHovered;
      this.tempRangeIndexes.sort((a,b) => a - b);

      this.monthsData.forEach((month, index) => {
        if ((this.tempRangeIndexes[0] < index) && (index < this.tempRangeIndexes[1])) {
          month.isInRangeHovered = true;
        } else {
          month.isInRangeHovered = false;
        }
      });
    }
  }

  onClick(indexClicked) {
    this.tempRangeIndexes = [];
    if (this.rangeIndexes[0] === null) { // no range from yet
      this.rangeIndexes[0] = this.globalIndexOffset + indexClicked;
    } else if (this.rangeIndexes[1] === null) { // no range to yet or to equal to from

      this.rangeIndexes[1] = this.globalIndexOffset + indexClicked;
      this.rangeIndexes.sort((a,b) => a - b);

      this.monthsData.forEach((month, index) => {
        if ((this.rangeIndexes[0] <= index) && (index <= this.rangeIndexes[1])) {
          month.isInRange = true;
        }
        if (this.rangeIndexes[0] === index) {
          month.isUpperEdge = true;
        }
        if (this.rangeIndexes[1] === index) {
          month.isLowerEdge = true;
        }
      });
    } else { // if there is any range => init null null
      this.initMonthsData();
      this.initRangeIndexes();
      this.sliceDataIntoView();
      this.onClick(indexClicked);
    }
    this.checkDisabledButtons();
  }

  apply() {
    let fromMonthYear = this.monthsData[this.rangeIndexes[0]];
    let toMonthYear = this.monthsData[this.rangeIndexes[1]];

    if (fromMonthYear && toMonthYear == undefined) {
      toMonthYear = fromMonthYear;
      this.monthsData[this.rangeIndexes[0]].isInRange = true;
      this.monthsData[this.rangeIndexes[0]].isYearVisible = true;
    }

    let fromMonthName = fromMonthYear && fromMonthYear.monthName;
    let fromYear = fromMonthYear && fromMonthYear.monthYear;

    let toMonthName = toMonthYear && toMonthYear.monthName;
    let toYear = toMonthYear && toMonthYear.monthYear;

    let fromMonthToSend = this.convertToNumberWithLeadingZero(fromMonthName);
    let fromYearToSend = fromYear.toString();
    let toMonthToSend = this.convertToNumberWithLeadingZero(toMonthName);
    let toYearToSend = toYear.toString();

    this.onApplyRange(fromMonthToSend, fromYearToSend, toMonthToSend, toYearToSend);
    this.generateVisibleMonthsInRange();
    this.calendarHidden = true;
  }

  onCalendar(value) {
      this.isOnCalendar = value;
  }

  clear() {
    this.init();
  }

  closeCalendar() {
    this.calendarHidden = true;
  }

  toggleCalendar() {
    this.calendarHidden = !this.calendarHidden;
  }

  convertToNumberWithLeadingZero(monthName) {
    let monthNumber = this.months.indexOf(monthName) + 1;
    return monthNumber < 10 ? '0' + monthNumber : monthNumber;
  }

  monthHasIncome(displayedMonth) {
    const checkIncome = (month) => {
      const index = this.months.findIndex(m => m === month.monthName);
      return this.monthlyIncomes.map(m => m.yearMonth).includes(month.monthYear + '-' + (index < 9 ? '0' : '') + (index + 1));
    };

    if (displayedMonth.showEllipsis) {
      const ellipsedMonthIndex = this.monthsInRange.findIndex(m => m.monthName === displayedMonth.monthName && m.monthYear === displayedMonth.monthYear);
      const monthsToCheck = this.monthsInRange.slice(0, ellipsedMonthIndex).reverse();
      const firstVisibleMonthIndex = monthsToCheck.findIndex(m => m.isMonthVisible);
      const hiddenMonths = this.monthsInRange.slice(ellipsedMonthIndex - firstVisibleMonthIndex, ellipsedMonthIndex + 1);

      return hiddenMonths.some(m => checkIncome(m));
    } else
      return checkIncome(displayedMonth);
  }

}
